<template>
    <transition name="modal">
        <div class="scrape-application-modal" @click="$emit('close')" v-if="scrapeObject">
            <div class="scrape-application-modal-window" style="min-height: 500px; width: 750px;" @click.stop>
                <div class="scrape-application-modal-close" @click="$emit('close')">&times;</div>

                <h2 class="mb-6">Intresseanmälan inom <span v-if="scrapeObject.product_area_id == 1">massage</span><span v-if="scrapeObject.product_area_id == 2">personlig träning</span></h2>

                <div class="container-fluid">
                    <div class="row mb-2 pb-2 pt-2 border-bottom border-top">
                        <div class="col-9"><b>Namn</b></div>
                        <div class="col">{{ scrapeObject.name_person }}</div>
                    </div>
                    <div class="row mb-2 pb-2 border-bottom">
                        <div class="col-9"><b>Telefon</b></div>
                        <div class="col">{{ scrapeObject.phone }}</div>
                    </div>
                    <div class="row mb-2 pb-2 border-bottom">
                        <div class="col-9"><b>E-post</b></div>
                        <div class="col">{{ scrapeObject.email }}</div>
                    </div>
                    <div class="row mb-2 pb-2 border-bottom">
                        <div class="col-9"><b>Ort</b></div>
                        <div class="col">{{ scrapeObject.city }}</div>
                    </div>
                    <div class="row mb-2 pb-2 border-bottom">
                        <div class="col-9"><b>Jag är</b></div>
                        <div class="col"><ul class="ps-4 mb-0"><li v-for="cert in splittoarray(scrapeObject.certifications)">{{ cert }}</li></ul></div>
                    </div>
                    <div class="row mb-2 pb-2 border-bottom">
                        <div class="col-9"><b>Utbildning</b></div>
                        <div class="col">{{ scrapeObject.school }}</div>
                    </div>
                    <div class="row mb-2 pb-2 border-bottom">
                        <div class="col-9"><b>Jag har</b></div>
                        <div class="col"><ul class="ps-4 mb-0"><li v-for="doc in splittoarray(scrapeObject.documents)">{{ doc }}</li></ul></div>
                    </div>
                    <div class="row mb-2 pb-2 border-bottom">
                        <div class="col-9"><b>Typ av mottagning</b></div>
                        <div class="col"><ul class="ps-4 mb-0"><li v-for="locality in splittoarray(scrapeObject.locality)">{{ locality }}</li></ul></div>
                    </div>
                    <div class="row mb-2 pb-2 border-bottom">
                        <div class="col-9"><b>Hur hittade du oss?</b></div>
                        <div class="col">{{ scrapeObject.found_us_from }}</div>
                    </div>
                    <div class="row mb-2 pb-2 border-bottom">
                        <div class="col-9"><b>Meddelande</b></div>
                        <div class="col">{{ scrapeObject.message }}</div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ScrapeApplicationModal',

    props: {
        scrapeObject: { type: Object, default: null }
    },

    mounted () {
        jQuery('html').addClass('modal-open')
    },

    beforeDestroy () {
        jQuery('html').removeClass('modal-open')
    },

    methods: {
        splittoarray (string) {
            if (string != null) {
                return string.split(',')
            }
        }
    }
}
</script>
